import type { Address } from '@keyvue/one-api-client';

const forAddress = (address?: Address | null) => {
    if (address?.country === 'Nederland') {
        return '🇳🇱';
    }

    if (address?.country === 'België') {
        return '🇧🇪';
    }

    if (address?.country === 'Duitsland') {
        return '🇩🇪';
    }

    return '';
};

export default {
    forAddress,
};
